import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const EvaluarePsihologica = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Evaluarea Psihologică</h1>
          <p>
            Evaluarea psihologica este un demers psihologic care are ca scop
            identificare prezentei unor attribute sau precizarea surselor unor
            perturbari ale functionarii psihologice.
          </p>
          <p>
            Utilizam o diversitate de metode de evaluare, de la observatie si
            interviu pana la baterii de teste complexe pentru a identifica
            particularitatile functionarii psihice si a putea sprijini prin
            recomadari optime de interventie.
          </p>
          <p>
            In spatiul AWARE, prin serviciile de evaluare psihologica, urmarim
            sprijinirea omului in a-si intelege tulburarea, cu scopul de a
            contribui cat mai bine in procesul de recuperare psihica si
            preventie.
          </p>

          <p>
            Evaluarea psihologica recomandata de psihologii centrului AWARE se
            centreaza pe o perspectiva profund umanista in care avem in vedere
            in centrul preocuparilor noastre, persoana in individualitatea sa.
          </p>
          <p>
            Punem pret pe organizarea si realizarea evaluarii psihologice, pe
            concluziile emise in urma rapoartelor psihologice pentru a face cele
            mai bune recomandari si planuri de interventie celor care ne cer
            sprijinul.
          </p>
          <p>INSTRUMENTE</p>
          <p>
            Pe langa interviurile clinice de evaluare, utilizam baterii de teste
            complexe care acopera o plaja larga de simptome:
          </p>
          <ul>
            <li>chestionare de screening si diagnostic psihiatric</li>
            <li>
              instrumente pentru evaluarea deprsiei, anxietatii si
              psihopatologiei;
            </li>
            <li>
              instrumente de evaluare a comportamentului si nivelului de
              dezvoltare;
            </li>
            <li>instrumente de evaluare a inteligentei emotionale;</li>
            <li>instrumente de orientare vocationala;</li>
            <li>instrumente de evaluare a aptitudinilor si abilitatilor;</li>
            <li>
              instrumente pentru evaluarea socio-emotionala si a abilitatilor de
              relationare;
            </li>
          </ul>
          <p>
            In cadrul Centrului de Psihologie si Psihoterapie AWARE oferim
            servicii de evaluare psihologica pentru toate categoriile de varsta:
          </p>
          <ul>
            <li>evaluarea psihologica a copilului;</li>
            <li>evaluare psihologica a adolescentului;</li>
            <li>evaluarea psihologica a adultului si a varstnicului.</li>
          </ul>
          <p>Realizam urmatoarele tipuri de evaluari:</p>
          <ul>
            <li>evaluare cognitiva si neuropsihologica;</li>
            <li>Evaluare afectiva;</li>
            <li>evaluarea nivelului dezvoltarii psihologice</li>
            <li>evaluarea personalitatii</li>
            <li>evaluarea mecanismelor de coping;</li>
            <li>evaluarea cuplului;</li>
            <li>evaluarea modului de relationare;</li>
            <li>evaluare vocationala;</li>
          </ul>
          <div class="s-bubbles">
            <div class="s-bubble">EVALUARE COPII ȘI ADOLESCENȚI</div>
            <div class="s-bubble">EVALUARE VÂRSTNICI</div>
            <div class="s-bubble">EVALUARE ADULȚI</div>
            <div class="s-bubble">AVIZE PSIHOLOGIE</div>
            <div class="s-bubble">FIȘE DE HANDICAP</div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EvaluarePsihologica;
